import { isFullOfflineModeEnabled } from "../utils/fullOfflineMode";

export const isElectronOfflineRuntime = () =>
  typeof window !== "undefined" && Boolean(
    window.desktopOfflineMutations || window.desktopOrderQueue || window.desktopProductQueue
  );

export const shouldUseOfflineStorage = () =>
  isElectronOfflineRuntime() &&
  (isFullOfflineModeEnabled() || (typeof navigator !== "undefined" && navigator.onLine === false));

export const canSyncNow = () =>
  isElectronOfflineRuntime() &&
  !isFullOfflineModeEnabled() &&
  (typeof navigator === "undefined" || navigator.onLine !== false);
